// extracted by mini-css-extract-plugin
export var formContainer = "_ce-0";
export var message = "_ce-1";